<template>
  <div class="gauge-chart-situation">
    <div :id="'gaugeChart' + timeId" class="gauge-chart-box"></div>
    <!-- <countTo
      class="gauge-chart-num"
      :startVal="0"
      :endVal="usedData"
      :duration="2000"
      :decimals="usedData.toString().split('.')[1] ? usedData.toString().split('.')[1].length : 0"
      suffix="%"
      :style="
        `color:${progressColor};
         font-size:16px;`
      "
    ></countTo> -->
  </div>
</template>
<script>
// import countTo from 'vue-count-to';
import * as Echarts5 from 'echarts5.3.0';

export default {
  components: {
    // countTo,
  },
  props: {
    usedData: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      gaugeChart: null,
      timeId: new Date() * 1 + Math.random(),
      progressColor: '',
      progressAngle: -20,
    };
  },
  watch: {
    usedData: {
      handler() {
        this.getProgressConfig();
        if (this.progressColor) {
          this.renderGaugeChart();
        }
      },
      immediate: true,
    },
  },
  mounted() {
    this.gaugeChart = Echarts5.init(document.getElementById(`gaugeChart${this.timeId}`));
    this.renderGaugeChart();
    // 当窗口发生变化时
    window.addEventListener('resize', this.handleResize);
  },
  methods: {
    // 进度条配置
    getProgressConfig() {
      this.progressAngle = (1 - this.usedData / 100) * 220;
      if (this.usedData <= 60) {
        this.progressColor = 'rgb(41,156,70)';
      } else if (this.usedData <= 90) {
        this.progressColor = 'rgb(214,118,39)';
      } else {
        this.progressColor = 'rgb(212,74,58)';
      }
    },
    // 仪表盘渲染
    renderGaugeChart() {
      const option = {
        // series: [
        //   {
        //     // 最外圈三色仪表盘
        //     center: ['50%', '65%'], // 仪表盘位置(圆心坐标)
        //     type: 'gauge',
        //     startAngle: 200,
        //     endAngle: -20,
        //     radius: 55,
        //     min: 0,
        //     max: 100,
        //     // splitNumber: 4,
        //     axisLine: {
        //       lineStyle: {
        //         width: 5,
        //         color: [
        //           [0.6, 'rgb(41,156,70)'],
        //           [0.9, 'rgb(214,118,39)'],
        //           [1, 'rgb(212,74,58)'],
        //         ],
        //       },
        //     },
        //     pointer: {
        //       show: false,
        //     },
        //     axisTick: {
        //       show: false,
        //       length: 12,
        //       lineStyle: {
        //         color: 'auto',
        //         width: 2,
        //       },
        //     },
        //     splitLine: {
        //       show: false,
        //     },
        //     axisLabel: {
        //       show: false,
        //     },
        //     detail: {
        //       show: false,
        //     },
        //     data: [
        //       {
        //         value: 100,
        //       },
        //     ],
        //   },
        //   {
        //     // 灰色装进度条仪表盘
        //     center: ['50%', '65%'], // 仪表盘位置(圆心坐标)
        //     type: 'gauge',
        //     startAngle: 200,
        //     endAngle: -20,
        //     radius: 50,
        //     min: 0,
        //     max: 100,
        //     // splitNumber: 4,
        //     axisLine: {
        //       lineStyle: {
        //         width: 15,
        //         color: [[1, 'rgba(220,220,220,0.3)']],
        //       },
        //     },
        //     progress: {
        //       show: true,
        //       width: 15,
        //       overlap: true,
        //     },
        //     pointer: {
        //       show: false,
        //     },
        //     axisTick: {
        //       show: false,
        //     },
        //     splitLine: {
        //       show: false,
        //     },
        //     axisLabel: {
        //       show: false,
        //     },
        //     detail: {
        //       show: false,
        //     },
        //     data: [
        //       {
        //         value: 100,
        //       },
        //     ],
        //   },
        //   {
        //     // 进度条仪表盘
        //     z: 3,
        //     center: ['50%', '65%'], // 仪表盘位置(圆心坐标)
        //     type: 'gauge',
        //     startAngle: 200,
        //     endAngle: -20 + this.progressAngle,
        //     radius: 50,
        //     min: 0,
        //     max: 100,
        //     // splitNumber: 4,
        //     color: this.progressColor,
        //     axisLine: {
        //       lineStyle: {
        //         width: 15,
        //         color: [[1, this.progressColor]],
        //       },
        //     },
        //     pointer: {
        //       show: false,
        //     },
        //     axisTick: {
        //       show: false,
        //     },
        //     splitLine: {
        //       show: false,
        //     },
        //     axisLabel: {
        //       show: false,
        //     },
        //     detail: {
        //       show: false,
        //       fontSize: 16,
        //       fontWeight: 'bolder',
        //       offsetCenter: [0, 0],
        //       valueAnimation: true,
        //       formatter(value) {
        //         return `${value}%`;
        //       },
        //       color: this.progressColor,
        //     },
        //     data: [
        //       {
        //         value: this.usedData,
        //       },
        //     ],
        //   },
        // ],
        series: [
          {
            // 最外圈三色仪表盘
            center: ['50%', '65%'], // 仪表盘位置(圆心坐标)
            type: 'gauge',
            startAngle: 200,
            endAngle: -20,
            radius: 55,
            min: 0,
            max: 100,
            axisLine: {
              lineStyle: {
                width: 5,
                color: [
                  [0.6, 'rgb(41,156,70)'],
                  [0.9, 'rgb(214,118,39)'],
                  [1, 'rgb(212,74,58)'],
                ],
              },
            },
            pointer: {
              show: false,
            },
            axisTick: {
              show: false,
              length: 12,
              lineStyle: {
                color: 'auto',
                width: 2,
              },
            },
            splitLine: {
              show: false,
            },
            axisLabel: {
              show: false,
            },
            detail: {
              show: false,
            },
            data: [
              {
                value: 100,
              },
            ],
          },
          {
            // 灰色装进度条仪表盘
            center: ['50%', '65%'], // 仪表盘位置(圆心坐标)
            type: 'gauge',
            startAngle: 200,
            endAngle: -20,
            radius: 50,
            min: 0,
            max: 100,
            axisLine: {
              lineStyle: {
                width: 15,
                color: [[1, 'rgba(220,220,220,0.3)']],
              },
            },
            pointer: {
              show: false,
            },
            axisTick: {
              show: false,
            },
            splitLine: {
              show: false,
            },
            axisLabel: {
              show: false,
            },
            detail: {
              show: false,
            },
            data: [
              {
                value: 100,
              },
            ],
          },
          {
            // 进度条仪表盘
            // z: 3,
            center: ['50%', '65%'], // 仪表盘位置(圆心坐标)
            type: 'gauge',
            startAngle: 200,
            endAngle: -20,
            radius: 50,
            min: 0,
            max: 100,
            axisLine: {
              lineStyle: {
                width: 15,
                color: [[1, 'rgba(220,220,220,0.3)']],
              },
            },
            itemStyle: {
              color: this.progressColor,
            },
            progress: {
              show: true,
              width: 15,
              overlap: true,
            },
            pointer: {
              show: false,
            },
            axisTick: {
              show: false,
            },
            splitLine: {
              show: false,
            },
            axisLabel: {
              show: false,
            },
            detail: {
              show: true,
              fontSize: 16,
              fontWeight: 'bolder',
              offsetCenter: [0, 0],
              valueAnimation: true,
              formatter(value) {
                return `${value}%`;
              },
              color: this.progressColor,
            },
            data: [
              {
                value: this.usedData,
              },
            ],
          },
        ],
      };
      this.gaugeChart?.clear();
      this.gaugeChart?.setOption(option);
    },
    handleResize() {
      this.gaugeChart.resize();
    },
  },
};
</script>
<style lang="scss">
.gauge-chart-situation {
  position: relative;
  .gauge-chart-box {
    width: 200px;
    height: 90px;
  }
  .gauge-chart-num {
    display: inline-block;
    width: 45px;
    text-align: center;
    position: absolute;
    top: 50%;
    left: 39%;
  }
}
</style>
